import { useDispatch, useSelector } from "react-redux";
import {
  toggleSelectedItem,
  toggleUsePurchaseCredit,
  updateCoupon,
  reloadBuyItems,
  resetBuyItems,
  selectItems,
} from "@actions/buy-closet-items-actions";

export function useSelectedItemsIds() {
  return useSelector((state) => state.buyClosetItems.selectedItemsIds);
}

export function useSelectedItems() {
  const {
    selectedItemsIds,
    pendingClosetSales: { closet_items: closetItems },
  } = useSelector((state) => state.buyClosetItems);

  const selectedItems = closetItems
    ?.filter((closetItem) => selectedItemsIds.includes(closetItem.id));

  return selectedItems;
}

export function usePendingClosetSales() {
  return useSelector((state) => state.buyClosetItems.pendingClosetSales);
}

export function useToggleSelectedItem() {
  const dispatch = useDispatch();

  return (item) => dispatch(
    toggleSelectedItem(item),
  );
}

export function useToggleUsePurchaseCredit() {
  const dispatch = useDispatch();

  return () => dispatch(
    toggleUsePurchaseCredit(),
  );
}

export function useUpdateCoupon() {
  const dispatch = useDispatch();

  return (coupon) => dispatch(
    updateCoupon(coupon),
  );
}

export function useReloadBuyItems() {
  const dispatch = useDispatch();

  return async (closetId) => dispatch(
    reloadBuyItems(closetId),
  );
}

export function useResetBuyItems() {
  const dispatch = useDispatch();

  return () => dispatch(
    resetBuyItems(),
  );
}

export function useSelectItems() {
  const dispatch = useDispatch();

  return (itemsIds) => dispatch(
    selectItems(itemsIds),
  );
}
